(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // Only close search modal if not triggered by search icon click
      if (!this.isSearchIconClick) {
        this.closeSearchModal();
      }
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && !this.isSearchIconClick) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Search functionality script
  document.addEventListener('DOMContentLoaded', function () {
    const searchIcon = document.querySelector('.header__icon--search');
    const searchModal = document.querySelector('.header__search');
    const searchInput = document.getElementById('Search-In-Modal');
    const stickyHeader = document.querySelector('sticky-header');

    if (searchIcon && searchModal) {
      searchIcon.addEventListener('click', function (e) {
        e.preventDefault(); // Prevent any default behavior

        console.log(e, 'e');
        // if (!searchModal.hasAttribute('open')) {
        //   // console.log(e,"e")
        //   searchModal.setAttribute('open', '');
        //   if (searchInput) {
        //     searchInput.focus();
        //   }
        //   // Indicate this is a search icon click to prevent modal closure
        //   if (stickyHeader) {
        //     stickyHeader.isSearchIconClick = true;
        //     setTimeout(() => {
        //       stickyHeader.isSearchIconClick = false;
        //     }, 100); // Reset after a short delay
        //   }
        // }
        const detailsElement = this.closest('details');
        console.log(detailsElement, 'detailsElement', detailsElement.hasAttribute('open'));
        if (detailsElement) {
          // detailsElement.removeAttribute('open');
          if (!detailsElement.hasAttribute('open')) {
            return;
          }
        }
      });
    }

    const allSearchInputs = document.querySelectorAll('.custom-search-input');
    const allClearButtons = document.querySelectorAll('.custom-clear-button');
    const allCloseButtons = document.querySelectorAll('.search-modal__close-button');

    allClearButtons.forEach(function (clearButton) {
      clearButton.addEventListener('click', function () {
        const input = this.closest('.custom-search-bar').querySelector('.custom-search-input');
        if (input) {
          input.value = '';
          this.classList.add('hidden');
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.focus();
        }
      });
    });

    allCloseButtons.forEach(function (closeButton) {
      closeButton.addEventListener('click', function () {
        const input = this.closest('.custom-search-bar').querySelector('.custom-search-input');
        if (input) {
          input.value = '';
          const clearButton = this.closest('.custom-search-bar').querySelector('.custom-clear-button');
          if (clearButton) {
            clearButton.classList.add('hidden');
          }
          input.dispatchEvent(new Event('input', { bubbles: true }));
        }
        const detailsElement = this.closest('details');
        if (detailsElement) {
          detailsElement.removeAttribute('open');
        }
      });
    });

    allSearchInputs.forEach(function (input) {
      input.addEventListener('input', function () {
        const clearButton = this.closest('.custom-search-bar').querySelector('.custom-clear-button');
        if (this.value.trim() === '') {
          if (clearButton) {
            clearButton.classList.add('hidden');
          }
        } else {
          if (clearButton) {
            clearButton.classList.remove('hidden');
          }
        }
      });

      if (input.value.trim() === '') {
        const clearButton = input.closest('.custom-search-bar').querySelector('.custom-clear-button');
        if (clearButton) {
          clearButton.classList.add('hidden');
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
